import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './Devices.module.scss';

import { PlatformType } from '../../../proto/utils/conversions';
import MainWrapper from '../Utils/MainWrapper';

function Device({ name, type }) {
  const classes = [styles.device];
  switch (type) {
    case PlatformType.DESKTOP:
      classes.push(styles.desktop);
      break;
    case PlatformType.MOBILE:
      classes.push(styles.mobile);
      break;
    case PlatformType.TABLET:
      classes.push(styles.tablet);
      break;
    default:
      break;
  }

  return (
    <li className={classes.join(' ')}>
      <div id="type-icon" />
      <span>{name}</span>
    </li>
  );
}

Device.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

function Devices({ devices }) {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <MainWrapper caption={t('Devices')}>
      <div className={styles.list}>
        <ul className={styles.devices}>
          {devices.map((d) => <Device key={d.id} name={d.name} type={d.platform} />)}
        </ul>
      </div>
    </MainWrapper>
  );
}

Devices.propTypes = {
  devices: PropTypes.instanceOf(Array).isRequired,
};

export default Devices;
